export const SQLSCRIPTEXECUTED_CREATE_RESET = 'SQLSCRIPTEXECUTED_CREATE_RESET'
export const SQLSCRIPTEXECUTED_CREATE_SET_CREATED = 'SQLSCRIPTEXECUTED_CREATE_SET_CREATED'
export const SQLSCRIPTEXECUTED_CREATE_SET_ERROR = 'SQLSCRIPTEXECUTED_CREATE_SET_ERROR'
export const SQLSCRIPTEXECUTED_CREATE_SET_VIOLATIONS = 'SQLSCRIPTEXECUTED_CREATE_SET_VIOLATIONS'
export const SQLSCRIPTEXECUTED_CREATE_TOGGLE_LOADING = 'SQLSCRIPTEXECUTED_CREATE_TOGGLE_LOADING'
